<div class="overflow-hidden">
  <div class="items-scrolling" id="scrolling">
    <slot />
  </div>
</div>

<style>
  .overflow-hidden {
    width: 100%;
    height: fit-content;
    max-width: 1366px;
    margin: 0 auto;
    overflow: hidden;
  }
  .items-scrolling {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 30px 20px 10px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    position: relative;
    gap: 20px;
    /* scroll-behavior: smooth; */
  }
  @media (prefers-reduced-motion: no-preference) {
    .items-scrolling {
      scroll-behavior: smooth;
    }
  }
  .items-scrolling::-webkit-scrollbar-track {
    -webkit-box-shadow: no;
    background-color: var(--primary-color);
  }
  .items-scrolling::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--thumb-scroll-color);
  }

  @media (max-width: 450px) {
    .items-scrolling {
      padding: 0;
    }
  }
</style>
